/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_020: Question = {
  id: 'pres-020-diversite-ecosystemes-forestiers',
  oldId: '34',
  title: 'Diversité des écosystèmes forestiers',
  number: '3.4',
  description: ['(indice de diversité de Shannon appliqué aux types écologiques selon les données écoforestières)'],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};

export const question_pres_020_v2: Question = question_pres_020;
export const question_pres_020_v3: Question = question_pres_020;
